import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './facebookGatherMachine'
import * as fb2fa from './fb2fa'
import * as fbAboutSettings from './fbAboutSettings'
import * as fbAlbumPrivacy from './fbAlbumPrivacy'
import * as fbConnectedApps from './fbConnectedApps'
import * as fbCoverPhotoPrivacy from './fbCoverPhotoPrivacy'
import * as fbCurrentCoverPhoto from './fbCurrentCoverPhoto'
import * as fbDeleteChats from './fbDeleteChats'
import * as fbDeleteCommentsLikesReactions from './fbDeleteCommentsLikesReactions'
import * as fbDeletePages from './fbDeletePages'
import * as fbDeletePostsActivity from './fbDeletePostsAndActivity'
import * as fbDiscoverability from './fbDiscoverability'
import * as fbEngagementNotifications from './fbEngagementNotifications'
import * as fbFollowersPublicContent from './fbFollowersPublicContent'
import * as fbMessageRequests from './fbMessageRequests'
import * as fbPhotoTags from './fbPhotoTags'
import * as fbProfilePhotoPrivacy from './fbProfilePhotoPrivacy'
import * as fbSearchEngine from './fbSearchEngine'
import * as fbUnfriend from './fbUnfriend'
import * as fbUserNotifications from './fbUserActivityNotifications'
import * as fbViewingSharing from './fbViewingSharing'
import * as fbVisibility from './fbVisibility'
import * as fbWhatYoureTaggedIn from './fbWhatYoureTaggedIn'
import * as fbWhoCanConnect from './fbWhoCanConnect'
import { FBRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [FBRecommendationKey.FB_ABOUT_SETTINGS]: fbAboutSettings,
  [FBRecommendationKey.FB_VISIBILITY]: fbVisibility,
  [FBRecommendationKey.FB_WHO_CAN_CONNECT]: fbWhoCanConnect,
  [FBRecommendationKey.FB_WHAT_YOURE_TAGGED_IN]: fbWhatYoureTaggedIn,
  [FBRecommendationKey.FB_CONNECTED_APPS]: fbConnectedApps,
  [FBRecommendationKey.FB_PROFILE_PHOTO_PRIVACY]: fbProfilePhotoPrivacy,
  [FBRecommendationKey.FB_COVER_PHOTO_PRIVACY]: fbCoverPhotoPrivacy,
  [FBRecommendationKey.FB_CURRENT_COVER_PHOTO]: fbCurrentCoverPhoto,
  [FBRecommendationKey.FB_ALBUM_PRIVACY_V2]: fbAlbumPrivacy,
  [FBRecommendationKey.FB_PHOTO_TAGS_V2]: fbPhotoTags,
  [FBRecommendationKey.FB_SETUP_2FA]: fb2fa,
  [FBRecommendationKey.FB_DISCOVERABILITY]: fbDiscoverability,
  [FBRecommendationKey.FB_SEARCH_ENGINE]: fbSearchEngine,
  [FBRecommendationKey.FB_MESSAGE_REQUESTS]: fbMessageRequests,
  [FBRecommendationKey.FB_FOLLOWERS_PUBLIC_CONTENT]: fbFollowersPublicContent,
  [FBRecommendationKey.FB_VIEWING_SHARING]: fbViewingSharing,
  [FBRecommendationKey.FB_USER_ACTIVITY_NOTIFICATIONS]: fbUserNotifications,
  [FBRecommendationKey.FB_ENGAGEMENT_NOTIFICATIONS]: fbEngagementNotifications,
  [FBRecommendationKey.FB_CHANGE_NAME]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_CHANGE_NAME,
      ),
    ],
  },
  [FBRecommendationKey.FB_PUBLIC_VIEW]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_PUBLIC_VIEW,
      ),
    ],
  },
  [FBRecommendationKey.FB_WHERE_LOGGED_IN]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_WHERE_LOGGED_IN,
      ),
    ],
  },
  [FBRecommendationKey.FB_RECOGNIZED_DEVICES]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_RECOGNIZED_DEVICES,
      ),
    ],
  },
  [FBRecommendationKey.FB_OFF_PLATFORM_ACTIVITY]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_OFF_PLATFORM_ACTIVITY,
      ),
    ],
  },
  [FBRecommendationKey.FB_LOGIN_ALERTS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        FBRecommendationKey.FB_LOGIN_ALERTS,
      ),
    ],
  },
  [FBRecommendationKey.FB_UNFRIEND]: fbUnfriend,
  [FBRecommendationKey.FB_DELETE_POSTS]: fbDeletePostsActivity,
  [FBRecommendationKey.FB_DELETE_COMMENTS_REACTIONS_VOTES]:
    fbDeleteCommentsLikesReactions,
  [FBRecommendationKey.FB_DELETE_PAGE_LIKES]: fbDeletePages,
  [FBRecommendationKey.FB_DELETE_CHATS]: fbDeleteChats,
}

export const facebookRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
